import "./Contact.css"


const Contact = () => {
  return (
    <div className="form" id="contact">
        <h1>Contact </h1>
        <form action="https://formsubmit.co/regularguy2108@gmail.com"  method="POST">
            <label>Your Name</label>
            <input type="text" name="name" required />
            <label >Email</label>
            <input type="email" name="email" required />
            <label >Subject</label>
            <input type="text" name="subject" required/>
            <label >Message</label>
            <textarea rows="6" placeholder="Type Your Message Here" name="message" required></textarea>
            <button className="btn" >SEND</button>
        </form>
       
    </div>
  )
}

export default Contact